export default __webpack_public_path__ + "static/media/drizzle.eab90399.mov";